export const getPrimaryColor = (mode) => {
  return mode === "b2b" ? "#00838f" : "#ffda72";
};

export const ZH_FONT = `"Heiti TC","Heiti SC","PingFang TC","PingFang SC",
"Microsoft JhengHei","Noto Sans TC","Source Han Sans TC","Noto Sans CJK TC",
sans-serif`;

export const LINE_SEED_STACK = [
  "LINE Seed Sans",   // English/Latin
  "LINE Seed JP",     // Japanese
  "LINE Seed TW",     // Traditional Chinese
  "Noto Sans", "Noto Sans JP", "Noto Sans TC",
  "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen",
  "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
  "Arial", "sans-serif",
].join(",");